import { filter } from "rxjs";
import { v4 as uuidv4 } from 'uuid';
import { apiDefinition, cleanXParserFieldsFromSchema } from '../api';
const validateCleanSchema = (data, schema, validator) => validator.validate(schema, data);
export class Subscriber {
    constructor(_apiClient, _validator, _originChannel, _channel, _cleanSchema) {
        this._apiClient = _apiClient;
        this._validator = _validator;
        this._originChannel = _originChannel;
        this._channel = _channel;
        this._cleanSchema = _cleanSchema;
        this._subscription = undefined;
    }
    subscribe(callableFunction) {
        if (this._subscription === undefined) {
            this._apiClient.subscribe(this._originChannel, this._channel);
            this._subscription = this._apiClient.inbox.pipe(filter(msg => msg.getMessage().subject === this._channel))
                .pipe(filter(msg => validateCleanSchema(msg.getMessageData(), this._cleanSchema, this._validator)))
                .subscribe(msg => callableFunction(msg));
        }
    }
    sendAck(replyId) {
        this._apiClient.sendAck(replyId, this._originChannel);
    }
    unsubscribe() {
        if (this._subscription) {
            this._subscription.unsubscribe();
            this._apiClient.unsubscribe(this._originChannel, this._channel);
        }
    }
}
export class Publisher {
    constructor(_apiClient, _validator, _originChannel, _channel, _publishDefinition) {
        this._apiClient = _apiClient;
        this._validator = _validator;
        this._originChannel = _originChannel;
        this._channel = _channel;
        this._publishDefinition = _publishDefinition;
    }
    send(data, targetId) {
        const messageDefinition = this._publishDefinition.message;
        const cleanSchema = cleanXParserFieldsFromSchema(messageDefinition.payload);
        if (!validateCleanSchema(data, cleanSchema, this._validator))
            return console.log(`❌ [Channel:${this._channel}][Type: publish] Error: Not validated message`);
        const dataWrapper = {
            metadata: {
                originChannel: this._originChannel,
                targetId: targetId,
            },
            data: data,
        };
        const ceMsg = {
            specversion: "1.0",
            id: uuidv4(),
            type: messageDefinition.name,
            time: new Date().toISOString(),
            source: this._apiClient.name,
            subject: this._channel,
            data: dataWrapper
        };
        this._apiClient.send(ceMsg);
    }
}
export const createChannel = (apiClient, validator, originChannel, params) => {
    const output = {};
    const channelDefinition = apiDefinition.channels[originChannel];
    let channel = originChannel;
    const parameters = channelDefinition.parameters;
    if (!params)
        throw Error(`Parameters not found for channel ${originChannel} review channel definition`);
    for (let key in parameters) {
        const textToSearch = `{${key}}`;
        if (originChannel.includes(textToSearch) && Object.keys(params).includes(key)) {
            channel = channel.replace(textToSearch, params[key]);
        }
        else
            throw new Error(`Parameter ${key} Not Found in channel ${originChannel}`);
    }
    if (channelDefinition.subscribe)
        output['subscriber'] = new Subscriber(apiClient, validator, originChannel, channel, cleanXParserFieldsFromSchema(channelDefinition.subscribe.message.payload));
    if (channelDefinition.publish)
        output['publisher'] = new Publisher(apiClient, validator, originChannel, channel, channelDefinition.publish);
    return output;
};
